module.exports = __webpack_public_path__ + "static/sparks.3eb316f3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sparks.gif
// module id = 1313
// module chunks = 168707334958949